import React, {} from 'react';

import './index.scss';

function AuthenticationCallback() {

  return <div id="authentication-callback-main">
    <ht-spinner />
  </div>;

}

export default AuthenticationCallback;